import type { LegalReference } from './finding.model';

export interface VacationAccount {
  personId: string;
  year: number;
  balanceType: string;
  unit: 'days' | 'hours';
  entitlement: number;
  carryOver: number;
  available: number;
  taken: number;
  approved: number;
  requested: number;
  remaining: number;
  asOf: string;
  entitlementSource: 'row' | 'derived' | 'override';
  legalReference: LegalReference | null;
  /** Grant days currently computable for a future year; null for current/past years. */
  projectedEntitlement: number | null;
  /** True when the view's numbers rest on projection; employment may still change before the grant posts, so display must badge it. */
  projected: boolean;
}

export function remainingOf(account: Pick<VacationAccount, 'available' | 'taken' | 'approved' | 'requested'>): number {
  return account.available - (account.taken + account.approved + account.requested);
}
